import { useEffect, useLayoutEffect } from 'react';

/**
 * isomorphic version of useLayoutEffect
 */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
